import { v4 } from 'uuid';

module.exports = {
  v4,
};
